module.exports = __webpack_public_path__ + "img/playne-arrow-dba.5240f673.svg";